
import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import { NotificationSetting, TargetSelection, NotificationSettingConfig } from 'ah-api-gateways';
import NotificationTargetEditModal from '@/app/components/settings/notifications/NotificationTargetEditModal.vue';
import TargetListDescription from '@/app/components/user/TargetListDescription.vue';

@Component({
  components: {
    NotificationTargetEditModal,
    TargetListDescription,
  },
})
export default class SingleNotificationTargetEditForm extends Vue {
  @Prop({ required: true }) config!: NotificationSettingConfig;

  @Prop({ required: true }) notification!: NotificationSetting;

  @Prop({ default: false }) showTitles!: boolean | string;

  @Prop({ default: false }) readonly!: boolean | string;

  notificationRecipients: TargetSelection[] = [];

  @Watch('notification', { immediate: true })
  resetData() {
    this.notificationRecipients = [...this.notification.to];
  }

  onNotificationUpdate(notification: NotificationSetting) {
    this.$emit('update:notification', notification);
    this.notificationRecipients = [...notification.to];
  }

  get hasTargets() {
    return this.notificationRecipients.length > 0;
  }

  get titlesShown() {
    return this.showTitles !== false;
  }
}
